import React, { memo } from 'react';
import cn from 'classnames';

import { Icon } from 'components';
import type { IconProps } from 'components/Icon';

import styles from './IconButton.module.scss';

export interface IconButtonProps
  extends IconProps,
    React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Custom button style */
  style?: Record<string, unknown>;
  /** custom class name for icon */
  iconClassName?: string;
}

export const IconButton: React.FC<IconButtonProps> = memo(
  ({ size, iconName, className, iconClassName, ...props }) => {
    const contentClassNames = cn([styles.IconButton], className);

    return (
      <button className={contentClassNames} data-testid="IconButton" {...props}>
        <Icon iconName={iconName} className={iconClassName} size={size} />
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';
